export default __webpack_public_path__ + "static/media/Twitter-Normal.95438f0c.png";